export default __webpack_public_path__ + "static/media/backdrop-image.71144f06.jpg";